import { Link } from "react-router";
import { ClickHereLinkProps } from "./ClickHereLink.types";
import { enableBackButton } from "lib/routing/navigate/navigate";
import { handleErrorModal } from "lib/redux/notifications";
import { useAppDispatch } from "lib/redux/hooks";

const ClickHereLink = ({ linkTo, linkText }: ClickHereLinkProps) => {
  const dispatch = useAppDispatch();
  const handleClick = () => {
    dispatch(handleErrorModal({ open: false, message: null }));

    // clickHereLink can be inside modal component
    // when modal is open, there is action to disable Android back button
    // we need to enable Android back button again if user clicks at clickHereLink
    enableBackButton();
  };
  return (
    <Link to={linkTo} onClick={handleClick}>
      {linkText ? linkText : "click here"}
    </Link>
  );
};

export default ClickHereLink;
